import { EditorState, EditorSelection } from '@codemirror/state'
import { keymap, EditorView, drawSelection, rectangularSelection, highlightActiveLine } from '@codemirror/view'
import { placeholder as placeholderExtension } from '@codemirror/view'
import { defaultKeymap, history, historyKeymap, indentWithTab } from '@codemirror/commands'
import { indentOnInput } from '@codemirror/language'
import { languages } from '@codemirror/language-data';
import { markdown } from "@codemirror/lang-markdown"

import getEditorConfig from "./config/editorConfig"
import markdocRichEditorPlugin from "./plugins/markdocRichEditorPlugin"

import { witerLightTheme } from './themes/witerLightTheme'

import { formattingKeymap } from "./extensions/formattingKeymap"
import { zettelLinker } from "./extensions/zettelLinker"
import { zettelExtractor } from "./extensions/zettelExtractor"

export class WiterEditor {
  constructor({
    parent,
    initialValue,
    onChange,
    tabSize = 2,
    boxSlug,
    mode = "show",
    placeholder = "A Zettel is never finished..."
  }) {
    const config = getEditorConfig({ mode });

    const baseExtensions = [
      markdocRichEditorPlugin(config), // Handles all the styling and editor show / edit logic
      witerLightTheme
    ];

    const editExtensions = config.mode === "edit" ? [
      EditorView.updateListener.of((update) => {
        if (update.docChanged && onChange) {
          onChange(update.state.doc.toString());
        }
      }),
      keymap.of([indentWithTab, ...defaultKeymap, ...historyKeymap, ...formattingKeymap]),
      highlightActiveLine(),
      drawSelection(),
      rectangularSelection(),
      indentOnInput(),
      history(),
      zettelLinker({ boxSlug }),
      zettelExtractor({ boxSlug }),
      placeholderExtension(placeholder)
    ] : [];

    const showExtensions = config.mode === "show" ? [
      EditorState.readOnly.of(true),
      EditorView.editable.of(false)
    ] : [];

    const extensions = [
      ...baseExtensions,
      ...editExtensions,
      ...showExtensions
    ];

    const state = EditorState.create({
      doc: initialValue || "",
      extensions,
      tabSize
    });

    this.editorView = new EditorView({
      state,
      parent
    });

    this.editorView.dom.style.minHeight = "200px";
  }

  destroy() {
    this.editorView.destroy();
  }
}
